import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId/options')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/options-page')),
  staticData: { titleKey: 'options' },
});
